// 根据当前域名动态选择后端 URL
// export const BACKEND_BASE_URL = window.location.hostname.includes('localhost') 
//   ? "http://localhost:4000/car_api"
//   : "https://my-app-alb-518397458.us-west-1.elb.amazonaws.com/car_api";

export const BACKEND_BASE_URL = window.location.hostname.includes('localhost') 
? "http://localhost:4000/car_api"
: "/car_api"; // 使用相对路径，CloudFront会代理到ALB

// wordpress url
export const WEB_URL = "https://www.bluesky-tour.com/";

/**
 * 服务类型
 */
export enum SERVICE_TYPE {
  /** 接机 */
  AIRPORT_PICK_UP = 0,
  /** 送机 */
  AIRPORT_DROP_OFF = 1,
  /** 包车 */
  CHARTER = 2,
  /** 其他 */
  OTHER = 3,
}

/**
 * 支付方式
 * 现金，信用卡，记账，支票，zelle,venmo
 * cash, credit card, account billing, check, Zelle, and Venmo.
 */
export enum PAYMENT_TYPE {
  /** 现金 */
  CASH = 1,
  /** 信用卡 */
  CREDIT_CARD = 2,
  /** 记账 */
  ACCOUNT_BILLING = 3,
  /** 支票 */
  CHECK = 4,
  /** Zelle */
  ZELLE = 5,
  /** Venmo */
  VENMO = 6,
}

/**
 * 订单状态
 */
export enum ORDER_STATUS {
  NONE = 0,
  INIT = 1,
  SUCCESS = 2,
  FAILED = 3,
}

export enum SERVER_ORDER_STATUS {
  UNCONFIRMED = 0,
  ASSIGNED = 1,
  INPROGRESS = 2,
  INCOMPLETE = 3,
  CANCELED = 4,
  COMPLETED = 5,
}

/**
 * 评价提供者
 */
export enum commentType {
  CUSTOMER_PROVIDED = 1,
  DRIVER_PROVIDED = 2,
  SYSTEM_PROVIDED = 3,
}

/**
 * 日志提供者
 */
export enum oplogType {
  DRIVER_PROVIDED = 1,
  MANAGER_PROVIDED = 2,
  SYSTEM_PROVIDED = 3,
}

/**
 * 服务类型
 */
export enum serviceType {
  /** 接机 */
  AIRPORT_PICK_UP = 0,
  /** 送机 */
  AIRPORT_DROP_OFF = 1,
  /** 包车 */
  CHARTER = 2,
  /** 其他 */
  OTHER = 3,
}

/**
 * 订单状态
 */
export enum orderStatus {
  INIT = 0,
  /** 已审核价格 */
  REVIEWED = 1,
  /** 已确认 */
  CONFIRMED = 2,
  /** 已分配司机 */
  ASSIGNED = 3,
  /** 已完成 */
  COMPLETED = 4,
  /** 已取消 */
  CANCELED = 5,
}

export enum customerType {
  EMAIL= 1,
  GOOGLE= 2,
  GUEST= 3,
};

export enum vehicleType {
  MINIVAN= 1, // miniVan
  LUXURYSUV= 2, // luxurySuv
};

// 首先在文件顶部添加州的列表
export const states = [
  'AL - Alabama', 'AZ - Arizona', 'AR - Arkansas', 'CA - California', 
  'CO - Colorado', 'CT - Connecticut', 'DE - Delaware', 'FL - Florida', 
  'GA - Georgia', 'ID - Idaho', 'IL - Illinois', 'IN - Indiana', 
  'IA - Iowa', 'KS - Kansas', 'KY - Kentucky', 'LA - Louisiana', 
  'ME - Maine', 'MD - Maryland', 'MA - Massachusetts', 'MI - Michigan', 
  'MN - Minnesota', 'MS - Mississippi', 'MO - Missouri', 'MT - Montana', 
  'NE - Nebraska', 'NV - Nevada', 'NH - New Hampshire', 'NJ - New Jersey', 
  'NM - New Mexico', 'NY - New York', 'NC - North Carolina', 'ND - North Dakota', 
  'OH - Ohio', 'OK - Oklahoma', 'OR - Oregon', 'PA - Pennsylvania', 
  'RI - Rhode Island', 'SC - South Carolina', 'SD - South Dakota', 
  'TN - Tennessee', 'TX - Texas', 'UT - Utah', 'VT - Vermont', 
  'VA - Virginia', 'WA - Washington', 'WV - West Virginia', 
  'WI - Wisconsin', 'WY - Wyoming'
];

export enum languages {
  CHINESE = "中文",
  ENGLISH = "English",
};

export const contactMethod = {
  PHONE: "phone",
  LINE: "line",
  WECHAT: "wechat",
  EMAIL: "email",
} as const;

export enum customerStatus {
  NORMAL = 0,
  WARN = 1,
  BAN = 2,
};

export const airports = [
  "LAX-Los Angeles Airport",
  "BUR-Hollywood Burbank Airport",
  "ONT-Ontario Airport",
  "LGB-Long Beach Airport",
  "SNA-John Wayne Airport"
];

export const passengersFields = [1, 2, 3, 4, 5, 6, 7];
export const luggagesFields = [0, 1, 2, 3, 4, 5, 6];//, 7];
export const carryOnFields = [0, 1, 2, 3, 4, 5, 6];//, 7];

export const wrongFare = 9991999;
export const wrongTips = 99999;

export const defaultState = 'CA';

export const bookingBeforeHours = 3;
